import React from 'react';

export default function AreaSummarySection({ summary }) {
  return (
    <section className="scapp-area-summary" aria-label="Resumen por centros">
      <div className="scapp-area-summary__header">
        <div>
          <h2>Resumen por centros</h2>
          <span>{summary.selectionLabel} · {summary.periodLabel}</span>
        </div>
        <label>
          Período
          <select aria-label="Período del resumen" value={summary.period} onChange={event => summary.setPeriod(event.target.value)}>
            <option value="">Período completo</option>
            {summary.periods.map(period => <option key={period.value} value={period.value}>{period.label}</option>)}
          </select>
        </label>
      </div>
      <div className="scapp-area-summary__kpis">
        {summary.kpis.map(kpi => (
          <div key={kpi.key}>
            <span>{kpi.label}</span>
            <strong style={{ color: kpi.color }}>{kpi.value}</strong>
          </div>
        ))}
      </div>
      <div className="scapp-area-summary__metrics" role="group" aria-label="Métrica del resumen">
        {summary.metrics.map(metric => (
          <button key={metric.key} type="button" aria-pressed={metric.key === summary.metric.key} onClick={() => summary.setMetric(metric.key)}>
            {metric.label}
          </button>
        ))}
      </div>
      <div className="scapp-area-summary__bars" role="group" aria-label={summary.metric.label}>
        {summary.rows.map(row => (
          <button key={row.id} type="button" aria-pressed={row.selected} onClick={row.select} title={`Ver ${row.name}`}>
            <span className="scapp-area-summary__name">{row.name}</span>
            <span className="scapp-area-summary__track"><span style={{ width: row.width, background: summary.metric.color }} /></span>
            <strong>{row.value}</strong>
          </button>
        ))}
      </div>
    </section>
  );
}
